import { render, staticRenderFns } from "./ansi-abrasion.vue?vue&type=template&id=452475d0&"
import script from "./ansi-abrasion.vue?vue&type=script&lang=js&"
export * from "./ansi-abrasion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports